<page-title text="404 Page Error | BitOasis" i18n-text="@@pageTitle.pageNotFound"></page-title>
<site-layout class="narrow push">
  <div class="wrapper text-center">
      <div class="img">
        <img src="assets/images/404.svg" alt="404 Page Not Found">
      </div>
      <h3 class="title" i18n="@@front.pageNotFound.title">Page not found</h3>
      <p class="text" i18n="@@front.pageNotFound.desciption">The page you are looking for doesn’t exists or another error occurred. That’s all we know.</p>
      <a routerLink="/" class="btn btn-primary" i18n="@@front.pageNotFound.backButton">Go back to home page</a>
  </div>
</site-layout>